import { useStyles } from '@chakra-ui/react';
import React from 'react';
import './App.css';
import AboutMe from './Component/AboutMe';
import AllRoutes from './Component/AllRoutes';
import Home from './Component/Home';
import Navbar from './Component/Navbar';
import {FaHeart} from 'react-icons/fa'
import Projects from './Component/Projects';
import Skills from './Component/Skills';
import Contact from './Component/Contact';
import Experience from './Component/Experience';
import Education from './Component/Education';
function App() {
    // const [spin, setSpin] = React.useState(0);

    // const classes= useStyles();

    // const refreshCanvas = () => {
    //     setSpin(1);
    //     console.log("Refreshed");
    // };
  return (
    <div className="App">
    
       <div>
       <Navbar/>
       </div>
       
       <div>
       <Home/>
       <AboutMe/>
       <Education/>
       <Experience/>
       <Projects/>
       <Skills/>
       <Contact/>
       </div>
     
    </div>
  );
}

export default App;
